import { ISidebarConfig, ISidebarState, ILayoutConfig, ILayoutState } from './types.d'

export const SIDEBAR_DEFAULT_WIDTH = 300
export const SIDEBAR_DEFAULT_MINIMAL_WIDTH = 80
export const SIDEBAR_DEFAULT_COMPACT_WIDTH = 20
export const SIDEBAR_DEFAULT_MAX_WIDTH = 600
export const SIDEBAR_DEFAULT_MIN_WIDTH = 200
export const SIDEBAR_DEFAULT_RESIZABLE = true
export const SIDEBAR_DEFAULT_COLLAPSIBLE = true
export const SIDEBAR_DEFAULT_COLLAPSE_STYLE = 'minimal'
export const SIDEBAR_OVERLAY_EXPANDABLE = false
export const DRAG_HANDLE_WIDTH = 4

export const DEFAULT_SIDEBAR_CONFIG: ISidebarConfig = {
  defaultWidth: SIDEBAR_DEFAULT_WIDTH,
  resizable: SIDEBAR_DEFAULT_RESIZABLE,
  collapsible: SIDEBAR_DEFAULT_COLLAPSIBLE,
  collapseStyle: SIDEBAR_DEFAULT_COLLAPSE_STYLE,
  overlayExpandable: SIDEBAR_OVERLAY_EXPANDABLE,
  minimalWidth: SIDEBAR_DEFAULT_MINIMAL_WIDTH,
  compactWidth: SIDEBAR_DEFAULT_COMPACT_WIDTH,
  maxWidth: SIDEBAR_DEFAULT_MAX_WIDTH,
  minWidth: SIDEBAR_DEFAULT_MIN_WIDTH
}

export const DEFAULT_SIDEBAR_STATE: ISidebarState = {
  collapsed: false,
  overlayExpanding: false,
  currenWidth: SIDEBAR_DEFAULT_WIDTH
}

export const INITIAL_LAYOUT_CONFIG: ILayoutConfig = {
  default: {
    sidebar: DEFAULT_SIDEBAR_CONFIG
  }
}

export const INITIAL_LAYOUT_STATE: ILayoutState = {
  default: {
    sidebar: DEFAULT_SIDEBAR_STATE
  }
}
